<template>
  <div>
        <b-modal v-model="modalShow"  id="some-modal-id"
  ok-only size="xl" hide-footer >
  <p class="acesseRapido" style="font-size:27px;font-weight: 700;font-size: 22px;margin-bottom: 0.0rem;color: gray;text-align:center !important;">Glossário</p>
            <p  style="font-size: 19px;color: #b4b4b4; text-align: center !important;"> Guia de capitulo dos serviços</p>
  <div style="width:90%;display:flex; margin:0 auto ;  justify-content: space-between; border-top:4px solid #e6e6e6;padding-top:30px; ">
  <div style="font-size:13px;margin-right: 17px" > <span style="margin-right:20px;"> 1</span>	SERVIÇOS DE INFORMÁTICA E CONGÊNERES<br>	
<span style="margin-right:20px;margin-bottom:30px;"> 2</span> 	SERVIÇOS DE PESQUISAS E DESENVOLVIMENTO DE QUALQUER NATUREZA	<br>
<span style="margin-right:20px;"> 3</span> 	SERVIÇOS PRESTADOS MEDIANTE LOCAÇÃO, CESSÃO DE DIREITO DE USO E CONGÊNERES	<br>
<span style="margin-right:20px;"> 4</span> 	SERVIÇOS DE SAÚDE, ASSISTÊNCIA MÉDICA E CONGÊNERES	<br>
<span style="margin-right:20px;"> 5</span>	SERVIÇOS DE MEDICINA E ASSISTÊNCIA VETERINÁRIA E CONGÊNERES<br>	
<span style="margin-right:20px;"> 6</span>	SERVIÇOS DE CUIDADOS PESSOAIS, ESTÉTICA, ATIVIDADES FÍSICAS E CONGÊNERES	<br>
<span style="margin-right:20px;"> 7</span>	SERVIÇOS RELATIVOS A ENGENHARIA, ARQUITETURA, GEOLOGIA, URBANISMO, CONSTRUÇÃO CIVIL, <br>
<span style="margin-right:20px;"> 8</span>	SERVIÇOS DE EDUCAÇÃO, ENSINO, ORIENTAÇÃO PEDAGÓGICA E EDUCACIONAL, INSTRUÇÃO, TREINAMENTO E AVALIAÇÃO PESSOAL DE QUALQUER GRAU OU NATUREZA	<br>
<span style="margin-right:20px;"> 9</span>	SERVIÇOS RELATIVOS A HOSPEDAGEM, TURISMO, VIAGENS E CONGÊNERES	<br>
<span style="margin-right:20px;"> 10</span>	SERVIÇOS DE INTERMEDIAÇÃO E CONGÊNERES	<br>
<span style="margin-right:20px;"> 11</span>	SERVIÇOS DE GUARDA, ESTACIONAMENTO, ARMAZENAMENTO, VIGILÂNCIA E CONGÊNERES	<br>
<span style="margin-right:20px;">12</span>	SERVIÇOS DE DIVERSÕES, LAZER, ENTRETENIMENTO E CONGÊNERES	<br>
<span style="margin-right:20px;">13</span>	SERVIÇOS RELATIVOS A FONOGRAFIA, FOTOGRAFIA, CINEMATOGRAFIA E REPROGRAFIA	<br>
<span style="margin-right:20px;"> 14</span>	SERVIÇOS RELATIVOS A BENS DE TERCEIROS	<br>
<span style="margin-right:20px;"> 15</span>	SERVIÇOS RELACIONADOS AO SETOR BANCÁRIO OU FINANCEIRO, INCLUSIVE AQUELES PRESTADOS POR INSTITUIÇÕES FINANCEIRAS AUTORIZADAS A FUNCIONAR PELA UNIÃO OU POR QUEM DE DIREITO	<br>
<span style="margin-right:20px;"> 16</span>	SERVIÇOS DE TRANSPORTE DE NATUREZA MUNICIPAL	<br>
<span style="margin-right:20px;"> 17</span>	SERVIÇOS DE APOIO TÉCNICO, ADMINISTRATIVO, JURÍDICO, CONTÁBIL, COMERCIAL E CONGÊNERES	<br>
<span style="margin-right:20px;"> 18</span>	SERVIÇOS DE REGULAÇÃO DE SINISTROS VINCULADOS A CONTRATOS DE SEGUROS; INSPEÇÃO E AVALIAÇÃO DE RISCOS PARA COBERTURA DE CONTRATOS DE SEGUROS; PREVENÇÃO E GERÊNCIA DE RISCOS SEGURÁVEIS E CONGÊNERES	<br>
<span style="margin-right:20px;"> 19</span>	SERVIÇOS DE DISTRIBUIÇÃO E VENDA DE BILHETES E DEMAIS PRODUTOS DE LOTERIA, BINGOS, CARTÕES, PULES OU CUPONS DE APOSTAS, SORTEIOS, PRÊMIOS, INCLUSIVE OS DECORRENTES DE TÍTULOS DE CAPITALIZAÇÃO E CONGÊNERES	<br>
<span style="margin-right:20px;"> 20    </span>	SERVIÇOS PORTUÁRIOS, AEROPORTUÁRIOS, FERROPORTUÁRIOS, DE TERMINAIS RODOVIÁRIOS, FERROVIÁRIOS E METROVIÁRIOS	</div>
  <div  style="font-size:13px;    ;
">
<span style="margin-right:20px;"> 21    </span>	SERVIÇOS DE REGISTROS PÚBLICOS, CARTORÁRIOS E NOTARIAIS<br>	
<span style="margin-right:20px;"> 22    </span>	SERVIÇOS DE EXPLORAÇÃO DE RODOVIA	<br>
<span style="margin-right:20px;"> 23    </span>	SERVIÇOS DE PROGRAMAÇÃO E COMUNICAÇÃO VISUAL, DESENHO INDUSTRIAL E CONGÊNERES	<br>
<span style="margin-right:20px;"> 24    </span>	SERVIÇOS DE CHAVEIROS, CONFECÇÃO DE CARIMBOS, PLACAS, SINALIZAÇÃO VISUAL, BANNERS, ADESIVOS E CONGÊNERES	<br>
<span style="margin-right:20px;"> 25    </span>	SERVIÇOS FUNERÁRIOS	<br>
<span style="margin-right:20px;"> 26    </span>	SERVIÇOS DE COLETA, REMESSA OU ENTREGA DE CORRESPONDÊNCIAS, DOCUMENTOS, OBJETOS, BENS OU VALORES, INCLUSIVE PELOS CORREIOS E SUAS AGÊNCIAS FRANQUEADAS; COURRIER E CONGÊNERES	<br>
<span style="margin-right:20px;"> 27    </span>	SERVIÇOS DE ASSISTÊNCIA SOCIAL	<br>
<span style="margin-right:20px;"> 28    </span>	SERVIÇOS DE AVALIAÇÃO DE BENS E SERVIÇOS DE QUALQUER NATUREZA	<br>
<span style="margin-right:20px;"> 29    </span>	SERVIÇOS DE BIBLIOTECONOMIA	<br>
<span style="margin-right:20px;"> 30    </span>	SERVIÇOS DE BIOLOGIA, BIOTECNOLOGIA E QUÍMICA	<br>
<span style="margin-right:20px;"> 31    </span>	SERVIÇOS TÉCNICOS EM EDIFICAÇÕES, ELETRÔNICA, ELETROTÉCNICA, MECÂNICA, TELECOMUNICAÇÕES E CONGÊNERES	<br>
<span style="margin-right:20px;"> 32    </span>	SERVIÇOS DE DESENHOS TÉCNICOS	<br>
<span style="margin-right:20px;"> 33    </span>	SERVIÇOS DE DESEMBARAÇO ADUANEIRO, COMISSÁRIOS, DESPACHANTES E CONGÊNERES	<br>
<span style="margin-right:20px;"> 34    </span>	SERVIÇOS DE INVESTIGAÇÕES PARTICULARES, DETETIVES E CONGÊNERES	<br>
<span style="margin-right:20px;"> 35    </span>	SERVIÇOS DE REPORTAGEM, ASSESSORIA DE IMPRENSA, JORNALISMO E RELAÇÕES PÚBLICAS	<br>
<span style="margin-right:20px;"> 36    </span>	SERVIÇOS DE METEOROLOGIA <br>	
<span style="margin-right:20px;"> 37    </span>	SERVIÇOS DE ARTISTAS, ATLETAS, MODELOS E MANEQUINS	<br>
<span style="margin-right:20px;"> 38    </span>	SERVIÇOS DE MUSEOLOGIA	<br>
<span style="margin-right:20px;"> 39    </span>	SERVIÇOS DE OURIVESARIA E LAPIDAÇÃO	<br>
<span style="margin-right:20px;"> 40    </span>	SERVIÇOS RELATIVOS A OBRAS DE ARTE SOB ENCOMENDA	<br>
  </div>
 </div>
 <br>
 <div style="display:flex;width:100%;justify-content:center;"> 
    <div >
        <button @click="modalShow = false" class="voltar">fechar</button>
    </div>
</div>
</b-modal>
      <div class="painel-p-rtfonte">
          <img src="https://www.lefisc.com.br/rtfonte/img/refont.png" alt="">
          <p>Saiba as retenções do IRRF, CSRF, INSS e ISS de forma simples e rápida.</p>
        </div>
        <div id="linhas">            
            <p>Categoria:</p>
            <select name="" id="" style="margin: 0px 20px;border: none; border-radius: 5px;height: 27px;" @change="onChange($event)" >
                <option :value="n.id" v-for="(n,i) in lista" :key="i" @change="selectAtual = n.id">
                    {{n.nome}}
                </option>
            </select>
        </div>
      
        <div class="espacamento">         
            <div class="dividir">
                <div class="itemSelecionado">
                    <div style="display:flex;align-items: center; margin-top: 25px;"> 
                        <p txtSelectAtual>{{lista[selectAtual-1].nome}} </p><span> {{lista[selectAtual-1].lado}}</span>
                    </div>
                    <p style="color:#94618E;font-size:15px">{{lista[selectAtual-1].subtitulo}}</p>
                </div>
                  <div class="acessoRapido" v-if="selectAtual ==1" @click="modalShow = !modalShow">
                  <img src="/rtfonte/img/pesquisar.svg" alt="" width="25" > Índice de Tópicos
                </div>
            </div>          
            <div v-if="selectAtual == 2">      
                <div v-html="autopecas.conteudo" style="margin-top:20px">

                </div>
                <hr>
                <h3 style="text-align:center;margin-top:20px;margin-bottom:20px">ANEXOS I e II da Lei nº 10.485/2002</h3>
            <div class="pesquisar">
                <select name="" id="" style="margin: 0px 20px;border: none; border-radius: 5px;height: 27px;" @change="onChangeNcm($event)" >
                    <option value="ncm">
                        NCM
                    </option>
                    <option value="descricao">
                        Descrição
                    </option>
                </select>
                <div class="pIn">
                    <img src="/rtfonte/img/pesquisarBlack.svg" width="20"/>
                    <input type="text" v-model="txtNcm" placeholder="Pesquisar" >
                </div>    
            </div>
             <h5 style="margin-top:25px;margin-bottom50px;font-weight:bold;">ANEXO I</h5>
                <table>
                    <thead>
                        <tr>
                            <th>NCM</th>
                            <th>Descrição</th>                           
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(n,i) in ListaNcmAnexo1" :key="i">
                            <td v-html="hig(n.ncm)" style="letter-spacing: -1px;width:110px;"></td>
                            <td v-html="hig(n.descricao)" style="text-align: justify;"></td>
                        </tr>
                    </tbody>
                </table>
                <h5 style="margin-top:25px;margin-bottom:5px;font-weight:bold;">ANEXO II</h5>
                <table>
                    <thead>
                        <tr>
                            <th>NCM</th>
                            <th>Descrição</th>  
                            <th>Condição</th>                         
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(n,i) in ListaNcmAnexo2" :key="i">
                            <td v-html="hig(n.ncm)" style="letter-spacing: -1px;width:110px;"></td>
                            <td v-html="hig(n.descricao)" style="    text-align: justify;"></td>
                            <td style="background-color: #fcf8e3;    text-align: justify;">{{n.condicao}}</td>
                        </tr>
                    </tbody>
                </table>
                
            </div>
            <div v-else-if="selectAtual == 3">
                <div v-html="orgaosPublicosFederais.conteudo" style="margin-top:20px">

                </div>
            </div>
       
            <div class="inputCaixa" v-if="selectAtual ==1">
                <form v-on:submit.prevent="pesquisar()" style="display:flex;">
                <input type="text"   v-model="texto" required=""> <button type="submit" style="margin-left:0px;"><img src="/rtfonte/img/pesquisar.svg" alt=""> Pesquisar</button>
                <label for="texto">buscar por palavra</label>
                </form>
                <p style="color:red;margin:10px 0px;">{{msg}}</p>
            </div>           
            <Numeracao @pegarAtual="atual =$event;chamarConteudoPaginaInicial(atual)" v-if="selectAtual ==1"/>
            <br>
            <div v-if="selectAtual ==1">
                <div v-if="mostraSke"> 
                    <span class="skeleton-loaderT"></span> 
                        <span class="skeleton-loader"></span> 
                        <span class="skeleton-loader"></span> 
                        <span class="skeleton-loader"></span> 
                        <span class="skeleton-loader"></span> 
                </div>
                <div v-for="(n,i) in this.dados" :key="i" >   
                <p txtTitulo v-if="!mostraSke">{{n.titulo}}</p>    
                <div v-for="(a,j) in n.array" :key="j">    
                    <div >
                        <Perguntas :pergunta="a.numero+' '+a.servico" :idItem="a.idItem" :id="a.numero"/>
                    </div>
                </div>
                </div>
            </div>
           
        </div>    
  </div>
</template>

<script>
import axios from 'axios'
import Numeracao from '../components/Numeracao.vue'
import Perguntas from '../components/Perguntas.vue'
import {link,token} from '../services/link.js'

export default {
    components:{
        Numeracao,
        Perguntas,  
    },
    directives:{
        changeCor: {
            bind(el, binding) {
                if(binding.value !== binding.oldValue){
                    el.oninput = (ev=>{
                        console.log(ev)
                        el.dispatchEvent(new Event('change'));
                    }, parseInt(binding.value) || 300)
                }
            const type = binding.arg;
            const fn = binding.value;
            el.addEventListener(type, fn)
            }
      }
    },
    computed:{
        ListaNcmAnexo1(){          
            if(this.ncm){
                return this.autopecas.anexo1.filter(e=> e.ncm.includes(this.txtNcm))   
            }        
           return this.autopecas.anexo1.filter(e=> e.descricao.includes(this.txtNcm))
        }, 
         ListaNcmAnexo2(){          
            if(this.ncm){
                return this.autopecas.anexo2.filter(e=> e.ncm.includes(this.txtNcm))   
            }        
           return this.autopecas.anexo2.filter(e=> e.descricao.includes(this.txtNcm))
        }, 
    },
    data(){
        return{  
            mostraSke:false,
            modalShow:false,  
            keyword:null,  
            queries: ['birds', 'scatt'],
            description: 'Tropical birds scattered as Drake veered the Jeep',
            ncm:true,
            txtNcm:'',
            orgaosPublicosFederais:[],
            autopecas:[],
            lista:[
                {   id:1,
                    "nome":"Lista de Serviços em Geral ",
                    "subtitulo":"Acesso Rápido Selecione o capítulo do serviço desejado entre as opções abaixo",
                    "lado":"| Acesso Rapido"
                },
                {   id:2,
                    "nome":"Autopeças – Lei nº 10.485/2002 – Retenção PIS e COFINS",
                    "subtitulo":"",
                    "lado":""
                },
                 {   id:3,
                    "nome":"Órgãos Públicos Federais/Estaduais/Municipais – Comercialização de Bens e Demais Operações Não Enquadradas na Lista de Serviços (LC nº 116/2003)",
                    "subtitulo":"",
                    "lado":""
                }
            ],
            msg:'',
            texto:'',
            pag:1,
            dados:[],
            atual:1,
            selectAtual:1
        }
    },    
    methods:{   
        async pesquisar(){          
                this.dados = []
                this.mostraSke = true
                this.carregamentoPag = true 
                this.texto = this.texto.trim()     
                await axios.post(`${link}/pesquisa/`, {
                    "termo": this.texto
                })
               .then(e=>{                 
                   for(let element of e.data){                       
                        if(element.serviço.length<=2){  
                            console.log(element.serviço)
                            this.dados.push({"idCat":element.idCat,"titulo":element.serviço+" "+element.categoria,"array":[]})                          
                       }
                   }
                   console.log(e.data)
                   for(let ele of this.dados){
                       for(let data of e.data){   
                           if(ele.idCat == data.idCat){ 
                               if(data.serviço.length>=3){
                                    ele.array.push({"idCat":data.idCat,"idItem":data.idItem,"numero":data.serviço,"servico":data.categoria}) 
                               }  
                           }
                       }            
                   }              
                   
               })            
            this.mostraSke = false
        },
        hig(txt){
            return txt.replace(new RegExp(this.txtNcm,'gi'), '<span class="hig">$&</span>')
        }  ,
        onChangeNcm(e){
            if(e.target.value == "ncm"){
                this.ncm = true
                return;
            }
            this.ncm = false
        } ,
        async onChange(e){
           this.selectAtual = e.target.value           
           if(this.selectAtual == 2){
               await axios.get('https://www.lefisc.com.br/api/retfonte/api/autopecas')
               .then(e=>this.autopecas = e.data)
           }else if(this.selectAtual == 3){
                await axios.get('https://www.lefisc.com.br/api/retfonte/api/orgaos-publicos-federais')
               .then(e=>this.orgaosPublicosFederais = e.data)
           }
            
        },
        async chamarConteudoPaginaInicial(id){
            this.dados = []
            this.mostraSke = true
            try{
                await axios.get(`${link}/titulo/${id}/${token}`)
                .then(async e=>{      
                    console.log(e)          
                    this.dados.push({"idCat":e.data[0].idCat,"titulo":e.data[0].idCat+` `+e.data[0].titulo,"array":[]})
                    await axios.get(`${link}/GeralporIdCatPaginado/${e.data[0].idCat}/${this.pag}/${token}`)
                    .then(e=>{                      
                        for(let element of e.data){   
                            console.log(element)                    
                            this.dados[0].array.push({"idItem":element.idItem,"idCat":element.idCat,"numero":element.n_servico,"servico":element.servico})
                        }                         
                    })
                })                
            }catch(e){
                console.log(e)
            }   
            this.mostraSke = false 
        }
    }
}
</script>

<style >
.skeleton-loader {
  width: 100%;
  height: 60px;
  border-radius:10px;
  margin-top:20px;
  display: block;
  background: linear-gradient(	  
      to right,
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 0.3) 50%,
      rgba(255, 255, 255, 0) 90%
    ),
    lightgray;
  background-repeat: repeat-y;
  background-size: 400px 10px;
  background-position: 0 0;
  animation: shine 1.5s infinite;	  
}
@keyframes shine {	
  to {
    background-position: 100% 100px, /* move highlight to right */ 0 0;
  }
}
.skeleton-loaderT{
  width: 40%;
  height: 25px;
  border-radius:5px;
  margin-top:20px;
  display: block;
  background: linear-gradient(	  
      to right,
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 0.5) 50%,
      rgba(255, 255, 255, 0) 80%
    ),
    lightgray;
  background-repeat: repeat-y;
  background-size: 50px 500px;
  background-position: 0 0;
  animation: shine 1s infinite;	  
}
@keyframes shine {	
  to {
    background-position: 100% 0, /* move highlight to right */ 0 0;
  }
}
p{
    text-align: justify !important;
}
.voltar button{
    height: 46px;
    width: 120px;
    border-radius: 7px;
    border: 2px solid #49274a;
    background: #fff;
    color: gray;
    font-style: italic;
    font-weight: 700;
    font-size: 18px;
    cursor: pointer;
    margin-top: 9px;
}
.voltar button:focus{
    outline: none;
}
.hig{
    color:rgb(226, 5, 5);
}
.pesquisar{
    height: 40px;
    display: flex;
    align-items: center;
box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
}
.pesquisar .pIn{
    position: relative;
     border-left: 1px solid rgb(27 31 35 / 15%);
    padding-left: 15px;
    display: flex;
    align-items: center;
    width:100%;
}
.pesquisar input{
    border:none;
   margin-left: 7px;
width:100%;
}
.pesquisar input:focus{
    outline: none;
}
table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}
td, th {
  border: 1px solid #dfdfdf;
  border-width: 1px !important;
  padding: 6px;
}
tr:nth-child(even) {
  background-color: #e9e8e8;
}
.dividir{
    padding-bottom: 8px;border-bottom: 1px solid #707070;display: flex;align-items: flex-end;justify-content: space-between;
}
li {
    text-align: justify;
    position: relative;
}
.acessoRapido:hover{
 background: #94618E;
   border:1px solid #94618E;
}
.acessoRapido{
    height: 38px;    position: relative;
    background: #49274A;
    color: #fff;
    border: 1px solid #49274A;
    width: 175px;
    text-transform: lowercase;
    font-size: 16px;   
    border-radius: 5px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-evenly   ;
    transition: 0.5s all;
}
.itemSelecionado{
    color:#4A154B;
}
.itemSelecionado p{
    margin-bottom: 0;
}
.itemSelecionado p{
font-size: 20px;
}
.itemSelecionado span{
font-size: 20px;
margin-left: 5px;
}
[txtSelectAtual]{
    
    font-weight: bold;
}
select:focus{
    outline: none;
}
[txtTitulo]{
    color:#616161;
    font-weight: bold;
    text-transform: uppercase;
    margin-bottom: -9px;
    margin-top:20px;
}
.espacamento{
    padding:30px;
}
.painel-p-rtfonte{
    height: 27vw;
    background-image: url('/rtfonte/img/back2.png'),
      linear-gradient(to top,#402341, #a26e9c );
    background-size: cover;
    background-repeat: no-repeat;
    background-blend-mode: multiply; 
    display: flex;    
    justify-content: flex-end;   
    align-items: center;
    flex-direction: column;  
}
.painel-p-rtfonte img{
    width: 25%;
}
.painel-p-rtfonte p{
   font-style: italic;
letter-spacing: -0.9px;
color: #F8EEE7;
    font-weight: 600;
    font-size: 18px;
    margin-bottom: 6%;
}
#linhas {
    width: 100%;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #4A154B
}
#linhas p{
    color:#fff;
    font-weight: bold;
    margin-bottom: 0px;
    font-size: 18px;
}
.inputCaixa{
    max-width: 521px;
    position: relative;
    margin:45px auto;
    height: 38px;    
}
.inputCaixa label{
    position: absolute;
    bottom:7px;
    opacity: 0.5;
    left:12px;
    font-size: 18px;
    color: #555;
    pointer-events: none;
    transition: 0.3s all;
}
.inputCaixa input{   
    width: 400px;
    outline: none;
    position: relative;
    z-index: 2;
    padding-left:20px;
    border: 1px solid #707070;
    background:none;   
}
.inputCaixa input:focus ~ label,
.inputCaixa input:valid ~ label{
    bottom:26px;
    background: #fff;
    opacity: 1;
    z-index: 3;
}
.inputCaixa  button{ 
    height: 38px;
    margin-left:-5px;
    position: relative;
    border-radius: 0px 5px 5px 0px;
    background: #49274A ;
    color:#fff;
    border:1px solid #49274A ;
    width: 120px;
    text-transform: lowercase;
    font-size:16px;
    padding-left:23px;
    outline: none;
    cursor: pointer;
}
.inputCaixa  button:hover{
  background: #94618E;
  border:1px solid #94618E;
}
.inputCaixa button img{
  margin-left: -8px;
  position: absolute;
  left:17px;
  top:10px;
width: 19px;
}
.inputCaixa button:hover img{
  width:20px;
}
</style>